import { DeepPartial, InstallGeothermalPackage } from 'types';

import { api } from './api';

export const installGeothermalPackageApi = api.injectEndpoints({
  endpoints: (build) => ({
    saveInstallGeothermalPackage: build.mutation<
      any,
      { accountId: string; savePackage: DeepPartial<InstallGeothermalPackage> }
    >({
      query: ({ accountId, savePackage }) => ({
        url: `v2/accounts/${accountId}/install-package/geothermal/save`,
        method: 'POST',
        body: { ...savePackage },
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: 'Accounts', id: arg?.accountId },
        { type: 'SystemDesign', id: arg?.accountId },
      ],
    }),
    submitInstallGeothermalPackage: build.mutation<
      any,
      { accountId: string; installPackage: InstallGeothermalPackage }
    >({
      query: ({ accountId, installPackage }) => ({
        url: `v2/accounts/${accountId}/install-package/geothermal/submit`,
        method: 'POST',
        body: { ...installPackage },
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: 'Accounts', id: arg?.accountId },
        { type: 'Queues', accountId: arg?.accountId },
        { type: 'SystemDesign', id: arg?.accountId },
        { type: 'AccountMilestones', id: arg?.accountId },
      ],
    }),
  }),
});

export const { useSaveInstallGeothermalPackageMutation, useSubmitInstallGeothermalPackageMutation } =
  installGeothermalPackageApi;
